<i18n>
{
  "fr": {
    "group-late": "En retard",
    "group-today": "Dû aujourd'hui",
    "group-upcoming": "À venir",
    "group-no-date": "Sans date"
  },
  "en": {
    "group-late": "Late",
    "group-today": "Due today",
    "group-upcoming": "Upcoming",
    "group-no-date": "No date"
  }
}
</i18n>

<template>
  <div>
    <div class="mb-6" v-for="group in groups" :key="group.title">
      <h3 class="title is-size-5 has-text-weight-bold pb-2">{{ group.title }}</h3>

      <template v-for="({ date, indicators }, index) in group.dates">
        <div class="is-relative columns my-5" :key="date">
          <div class="column py-0 is-2 is-size-5">
            <div v-if="date">
              <span class="year is-block has-text-grey is-size-6 has-text-weight-bold">
                {{ $format.dateTime(date, 'YYYY') }}
              </span>
              <span class="is-block has-text-primary has-text-weight-bold" :class="{ 'mb-2': $media.mobile }">{{
                $format.shortMonthDay(date)
              }}</span>
            </div>
          </div>
          <div class="column py-0" style="min-width: 0">
            <indicator-snippet
              v-for="indicator in indicators"
              :key="indicator.id"
              :data="indicator"
              show-note
              show-documents
              :condensed="$media.mobile"
            />
          </div>
        </div>

        <hr class="separator my-3" v-if="index < group.dates.length - 1" :key="`${date}-separator`" />
      </template>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import groupBy from 'lodash/groupBy'

import IndicatorSnippet from '@/components/dashboards/indicator-snippet'

export default {
  components: { IndicatorSnippet },
  props: {
    indicators: Array
  },
  computed: {
    groups() {
      if (!this.indicators || this.indicators.length === 0) return []

      const late = [],
        today = [],
        upcoming = [],
        noDate = []

      const todayDate = dayjs().format('YYYY-MM-DD')

      for (const indicator of this.indicators) {
        if (!indicator.targetDate) {
          noDate.push(indicator)
        } else if (indicator.targetDate === todayDate) {
          today.push(indicator)
        } else if (indicator.targetDate < todayDate) {
          late.push(indicator)
        } else {
          upcoming.push(indicator)
        }
      }

      const result = []

      function groupByDate(indicators) {
        return Object.entries(groupBy(indicators, (x) => x.targetDate)).map((x) => ({ date: x[0], indicators: x[1] }))
      }

      if (late.length > 0) {
        result.push({
          title: this.$t('group-late'),
          dates: groupByDate(late)
        })
      }
      if (today.length > 0) {
        result.push({
          title: this.$t('group-today'),
          dates: groupByDate(today)
        })
      }
      if (upcoming.length > 0) {
        result.push({
          title: this.$t('group-upcoming'),
          dates: groupByDate(upcoming)
        })
      }
      if (noDate.length > 0) {
        result.push({
          title: this.$t('group-no-date'),
          dates: [{ date: null, indicators: noDate }]
        })
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.year {
  line-height: 1;
}

.title {
  border-bottom: solid 3px $grey-lighter;
  position: relative;
}

.separator {
  position: relative;
}
</style>